/**
 * PriceInput — inline pax/group cost editor used in a list row. Stops click propagation so editing a price
 * never opens the row's drawer. Empty input maps to `null` (no price).
 */
import { User, Users } from 'lucide-react';

interface PriceInputProps {
  kind: 'pax' | 'group';
  value: number | null;
  currency: string;
  readOnly: boolean;
  onChange: (value: number | null) => void;
}

export function PriceInput({ kind, value, currency, readOnly, onChange }: PriceInputProps) {
  return (
    <label
      className="tp-list-price"
      onClick={(event) => event.stopPropagation()}
      title={kind === 'group' ? 'Za skupinu' : 'Za osobu'}
    >
      <span className="tp-list-price-ico" aria-hidden="true">
        {kind === 'group' ? <Users size={14} /> : <User size={14} />}
      </span>
      <input
        className="tp-list-price-input"
        type="number"
        min="0"
        step={kind === 'group' ? 100 : 10}
        value={value ?? ''}
        placeholder="0"
        disabled={readOnly}
        onClick={(event) => event.stopPropagation()}
        onChange={(event) => {
          const raw = event.target.value;
          if (raw === '') {
            onChange(null);
            return;
          }
          const parsed = Number(raw);
          if (!Number.isNaN(parsed)) onChange(parsed);
        }}
      />
      <span className="tp-list-price-cur">{currency}</span>
    </label>
  );
}
